var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{style:(_vm.cssVars),attrs:{"options":_vm.options},on:{"input":function($event){return _vm.$emit('update:content', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }